<div class="st-page">
  <div class="st-page-head">
    <div>
      <h1 class="st-title">{{ 'leaveManagement' | translate }}</h1>
    </div>
    <div class="lm-head-actions">
      <button type="button" class="lm-icon-btn" (click)="toggleSearch()">
        <i class="ri-search-line"></i>
      </button>
      <button type="button" class="lm-icon-btn" [class.lm-icon-btn-active]="hasActiveFilters" (click)="openFilterSheet()">
        <i class="ri-filter-3-line"></i>
      </button>
      <button type="button" class="lm-icon-btn" (click)="refreshList()">
        <i class="ri-refresh-line"></i>
      </button>
    </div>
  </div>

  <div class="sb-search-box" *ngIf="searchOpen">
    <i class="ri-search-line"></i>
    <input
      type="text"
      [ngModel]="searchString"
      (ngModelChange)="onSearchInput($event)"
      placeholder="{{ 'searchByStudentNamePlaceholder' | translate }}"
      autofocus
    />
    <i class="ri-close-line lm-search-clear" *ngIf="searchString" (click)="onSearchInput('')"></i>
  </div>

  <div class="st-tabs lm-status-tabs">
    <div class="st-tab" [class.active]="activeStatus === 'ALL'" (click)="selectStatus('ALL')">
      {{ 'all' | translate }} ({{ allCount }})
    </div>
    <div class="st-tab" [class.active]="activeStatus === 'PENDING'" (click)="selectStatus('PENDING')">
      {{ 'pending' | translate }} ({{ statusCounts.pending }})
    </div>
    <div class="st-tab" [class.active]="activeStatus === 'APPROVED'" (click)="selectStatus('APPROVED')">
      {{ 'approved' | translate }} ({{ statusCounts.approved }})
    </div>
    <div class="st-tab" [class.active]="activeStatus === 'REJECTED'" (click)="selectStatus('REJECTED')">
      {{ 'rejected' | translate }} ({{ statusCounts.rejected }})
    </div>
    <div class="st-tab" [class.active]="activeStatus === 'CANCELLED'" (click)="selectStatus('CANCELLED')">
      {{ 'cancelled' | translate }} ({{ statusCounts.cancelled }})
    </div>
  </div>

  <div class="lm-class-list" *ngIf="isLoading">
    <div class="st-card lm-skeleton-row" *ngFor="let s of skeletonRows"></div>
  </div>

  <ng-container *ngIf="!isLoading">
    <ng-container *ngIf="hasAnyLeaveRequests">
      <ng-container *ngFor="let group of classes">
        <div class="lm-section-divider" *ngIf="group.leaveRequests.length"><span>{{ group.className }}</span></div>
        <div class="lm-class-list" *ngIf="group.leaveRequests.length">
          <div class="st-card lm-leave-card" *ngFor="let item of group.leaveRequests" (click)="openLeaveDetails(item)">
            <div class="lm-card-top">
              <div class="lm-card-avatar">
                <img *ngIf="item.studentImage" [src]="item.studentImage" [alt]="item.studentName" />
                <ng-container *ngIf="!item.studentImage">{{ getInitials(item.studentName) }}</ng-container>
              </div>
              <div class="st-list-text">
                <div class="st-list-title">{{ item.studentName }}</div>
                <div class="lm-leave-type-row">
                  <span class="lm-leave-type">{{ item.leaveTypeName }}</span>
                  <i class="ri-attachment-2" *ngIf="item.attachments?.length"></i>
                </div>
              </div>
              <span class="st-chip" [ngClass]="statusChipClass(item.displayStatus)">{{ item.displayStatus | translate }}</span>
            </div>

            <div class="lm-card-daterow" *ngIf="item.startTime && item.endTime">
              {{ item.startDate }} &nbsp;&nbsp; {{ item.startTime }} &ndash; {{ item.endTime }}
            </div>
            <div class="lm-card-daterow" *ngIf="!(item.startTime && item.endTime)">
              {{ dateRangeLabel(item) }}
            </div>

            <div class="lm-card-reason">{{ item.reason }}</div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div class="st-empty-state" *ngIf="!hasAnyLeaveRequests && hasActiveFilters">
      <i class="ri-filter-off-line"></i>
      {{ 'noDataForFilter' | translate }}
      <button class="st-btn st-btn-secondary" (click)="clearFilter()">{{ 'clearFilter' | translate }}</button>
    </div>

    <div class="st-empty-state" *ngIf="!hasAnyLeaveRequests && !hasActiveFilters">
      <i class="ri-calendar-todo-line"></i> {{ 'noLeaveRequestsFound' | translate }}
    </div>

    <div class="sf-load-more" *ngIf="pageNumber < maxPageNumber">
      <button class="st-btn st-btn-secondary" (click)="loadMore()" [disabled]="loadingMore">
        {{ (loadingMore ? 'pleaseWait' : 'loadMore') | translate }}
      </button>
    </div>
  </ng-container>
</div>

<!-- Class/Date filter sheet -->
<div class="sb-drawer-overlay" *ngIf="showFilterSheet" (click)="closeFilterSheet()">
  <div class="sb-drawer" (click)="$event.stopPropagation()">
    <ng-container *ngIf="!activeDateField; else dateCalendarView">
      <div class="sb-drawer-head">
        <h3 class="sb-drawer-title">{{ 'filterBy' | translate }}</h3>
        <button class="sb-drawer-close" (click)="closeFilterSheet()"><i class="ri-close-line"></i></button>
      </div>

      <div class="sb-drawer-body">
        <button type="button" class="ci-clear-filter-btn" [class.ci-clear-filter-hidden]="!hasActiveFilters" (click)="clearFilter()">
          {{ 'clearFilter' | translate }}
        </button>

        <label class="sb-field-label">{{ 'classCategory' | translate }}</label>
        <select class="sb-native-select" [ngModel]="draftClassCategory" (ngModelChange)="onDraftClassCategoryChange($event)">
          <option [ngValue]="'All'">{{ 'all' | translate }}</option>
          <option *ngFor="let cat of classCategoryOptions" [ngValue]="cat.value">{{ cat.label }}</option>
        </select>

        <label class="sb-field-label">{{ 'classStandard' | translate }}</label>
        <select class="sb-native-select" [ngModel]="draftClassStandard" (ngModelChange)="onDraftClassStandardChange($event)" [disabled]="draftClassCategory === 'All'">
          <option [ngValue]="'All'">{{ 'all' | translate }}</option>
          <option *ngFor="let cs of classStandardOptions" [ngValue]="cs.value">{{ cs.label }}</option>
        </select>

        <label class="sb-field-label">{{ 'section' | translate }}</label>
        <select class="sb-native-select" [ngModel]="draftClassId" (ngModelChange)="onDraftClassIdChange($event)" [disabled]="draftClassStandard === 'All'">
          <option [ngValue]="'All'">{{ 'all' | translate }}</option>
          <option *ngFor="let section of classSectionOptions" [ngValue]="section.value">{{ section.label }}</option>
        </select>

        <label class="sb-field-label">{{ 'dateRange' | translate }}</label>
        <div class="lm-date-range-row">
          <button type="button" class="lm-date-field" (click)="openDateField('start')">
            <i class="ri-calendar-line"></i>
            {{ draftStartDateObj ? (draftStartDateObj | date: 'dd MMM yy') : ('startDate' | translate) }}
          </button>
          <button type="button" class="lm-date-field" [disabled]="!draftStartDateObj" (click)="openDateField('end')">
            <i class="ri-calendar-line"></i>
            {{ draftEndDateObj ? (draftEndDateObj | date: 'dd MMM yy') : ('endDate' | translate) }}
          </button>
        </div>
      </div>

      <div class="sb-drawer-actions">
        <button class="st-btn st-btn-secondary" (click)="closeFilterSheet()">{{ 'cancel' | translate }}</button>
        <button class="st-btn st-btn-primary" [disabled]="isDateRangeIncomplete" (click)="applyFilter()">{{ 'applyFilter' | translate }}</button>
      </div>
    </ng-container>

    <ng-template #dateCalendarView>
      <div class="sb-drawer-head">
        <h3 class="sb-drawer-title">{{ (activeDateField === 'start' ? 'startDate' : 'endDate') | translate }}</h3>
        <button class="sb-drawer-close" (click)="closeDatePicker()"><i class="ri-close-line"></i></button>
      </div>
      <div class="sb-drawer-body">
        <p-calendar
          [ngModel]="activeDateField === 'start' ? draftStartDateObj : draftEndDateObj"
          (onSelect)="onDraftDateSelected($event)"
          [minDate]="activeDateField === 'end' ? draftStartDateObj : null"
          [inline]="true"
        ></p-calendar>
      </div>
      <div class="sb-drawer-actions">
        <button class="st-btn st-btn-secondary" (click)="closeDatePicker()">{{ 'close' | translate }}</button>
      </div>
    </ng-template>
  </div>
</div>

<!-- Leave detail drawer -->
<div class="sb-drawer-overlay" *ngIf="showDetails && selectedLeave as leave" (click)="closeDetails()">
  <div class="sb-drawer" (click)="$event.stopPropagation()">
    <div class="sb-drawer-head">
      <h3 class="sb-drawer-title">{{ leave.leaveTypeName }}</h3>
      <button class="sb-drawer-close" (click)="closeDetails()"><i class="ri-close-line"></i></button>
    </div>

    <div class="sb-drawer-body">
      <span class="st-chip" [ngClass]="statusChipClass(leave.displayStatus)">{{ leave.displayStatus | translate }}</span>

      <p class="lm-details-reason">{{ leave.reason }}</p>

      <div class="lm-date-boxes">
        <div class="lm-date-box">
          <div class="lm-date-box-label">{{ 'startDate' | translate }}</div>
          <div class="lm-date-box-value"><i class="ri-time-line" *ngIf="isHalfDayLeave"></i> {{ isHalfDayLeave ? leave.startTime : leave.startDate }}</div>
        </div>
        <div class="lm-date-box">
          <div class="lm-date-box-label">{{ 'endDate' | translate }}</div>
          <div class="lm-date-box-value"><i class="ri-time-line" *ngIf="isHalfDayLeave"></i> {{ isHalfDayLeave ? leave.endTime : leave.endDate }}</div>
        </div>
      </div>

      <div class="lm-person-row">
        <div class="st-avatar lm-person-avatar">
          <img *ngIf="leave.studentImage" [src]="leave.studentImage" [alt]="leave.studentName" />
          <ng-container *ngIf="!leave.studentImage">{{ getInitials(leave.studentName) }}</ng-container>
        </div>
        <div class="st-list-text">
          <div class="lm-person-label">{{ 'appliedBy' | translate }}</div>
          <div class="lm-person-name">{{ leave.studentName }}</div>
        </div>
      </div>

      <div class="lm-person-row" *ngIf="leave.displayStatus === 'Approved' && leave.actionedByName">
        <div class="st-avatar lm-person-avatar">
          <img *ngIf="leave.actionedByImage" [src]="leave.actionedByImage" [alt]="leave.actionedByName" />
          <ng-container *ngIf="!leave.actionedByImage">{{ getInitials(leave.actionedByName) }}</ng-container>
        </div>
        <div class="st-list-text">
          <div class="lm-person-label"><i class="ri-check-line lm-approved-icon"></i> {{ 'approvedBy' | translate }}</div>
          <div class="lm-person-name">{{ leave.actionedByName }}</div>
        </div>
      </div>

      <div class="lm-person-row" *ngIf="leave.displayStatus === 'Rejected' && leave.actionedByName">
        <div class="st-avatar lm-person-avatar">
          <img *ngIf="leave.actionedByImage" [src]="leave.actionedByImage" [alt]="leave.actionedByName" />
          <ng-container *ngIf="!leave.actionedByImage">{{ getInitials(leave.actionedByName) }}</ng-container>
        </div>
        <div class="st-list-text">
          <div class="lm-person-label"><i class="ri-close-line lm-rejected-icon"></i> {{ 'rejectedBy' | translate }}</div>
          <div class="lm-person-name">{{ leave.actionedByName }}</div>
        </div>
      </div>

      <div class="lm-remark-box" *ngIf="leave.remarks && (leave.displayStatus === 'Approved' || leave.displayStatus === 'Rejected' || leave.displayStatus === 'Cancelled')">
        <div class="lm-remark-label">{{ 'remarks' | translate }}</div>
        <div class="lm-remark-text">{{ leave.remarks }}</div>
      </div>

      <ng-container *ngIf="leave.attachments?.length">
        <div class="sb-field-label">{{ attachmentsSectionLabel(leave.attachments.length) }}</div>
        <div class="sb-attachment-list">
          <div class="sb-attachment-row" *ngFor="let att of leave.attachments; let i = index" (click)="openAttachmentPreview(att)">
            <i class="ri-image-line" *ngIf="isImageAttachment(att)"></i>
            <i class="ri-file-pdf-line" *ngIf="!isImageAttachment(att)"></i>
            <span class="sb-attachment-name">{{ attachmentName(att, i) }}</span>
            <i class="ri-eye-line lm-attachment-view"></i>
          </div>
        </div>
      </ng-container>

      <div class="lm-action-row" *ngIf="leave.displayStatus === 'Pending'">
        <button class="st-btn st-btn-danger" (click)="openRemarkModal('REJECT')">{{ 'reject' | translate }}</button>
        <button class="st-btn st-btn-primary" (click)="openRemarkModal('APPROVE')">{{ 'approve' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<!-- Approve/Reject remark modal -->
<div class="lm-modal-overlay" *ngIf="showRemarkModal" (click)="closeRemarkModal()">
  <div class="lm-modal" (click)="$event.stopPropagation()">
    <h3 class="lm-modal-title">{{ (remarkModalAction === 'APPROVE' ? 'approveLeaveRequestTitle' : 'rejectLeaveRequestTitle') | translate }}</h3>
    <label class="sb-field-label">
      {{ 'reason' | translate }}
      <span class="lm-required-mark" *ngIf="remarkModalAction === 'REJECT'">*</span>
    </label>
    <textarea
      class="sb-textarea"
      rows="4"
      [(ngModel)]="remarkText"
      placeholder="{{ (remarkModalAction === 'APPROVE' ? 'enterApprovalRemarkPlaceholder' : 'enterRejectionReasonPlaceholder') | translate }}"
      [disabled]="actioning"
    ></textarea>
    <div class="lm-modal-actions">
      <button class="st-btn st-btn-secondary" (click)="closeRemarkModal()" [disabled]="actioning">{{ 'cancel' | translate }}</button>
      <button class="st-btn st-btn-primary" (click)="confirmAction()" [disabled]="actioning">
        {{ (actioning ? 'pleaseWait' : 'confirm') | translate }}
      </button>
    </div>
  </div>
</div>

<!-- In-app attachment preview — images render directly, everything else
     (PDFs/documents) in a sandboxed iframe, same pattern as the broadcast
     media preview overlay. -->
<div class="lm-attachment-preview-overlay" *ngIf="isAttachmentPreviewOpen && previewAttachment" (click)="closeAttachmentPreview()">
  <button type="button" class="lm-attachment-preview-close-btn" (click)="closeAttachmentPreview()">
    <i class="ri-close-line"></i>
  </button>
  <div class="lm-attachment-preview-content" [class.lm-attachment-preview-content-doc]="!isImageAttachment(previewAttachment)" (click)="$event.stopPropagation()">
    <ng-container *ngIf="isImageAttachment(previewAttachment); else documentPreview">
      <img [src]="attachmentUrl(previewAttachment)" [alt]="attachmentName(previewAttachment, 0)" class="lm-attachment-preview-image" />
    </ng-container>
    <ng-template #documentPreview>
      <iframe [src]="previewAttachmentSafeUrl" class="lm-attachment-preview-iframe" [title]="attachmentName(previewAttachment, 0)"></iframe>
    </ng-template>
    <div class="lm-attachment-preview-label">{{ attachmentName(previewAttachment, 0) }}</div>
  </div>
</div>
